import { types } from 'mobx-state-tree';

export default types.model('ShippingDetail', {
  delivery: types.string,
  label: types.string,
  brand: types.string,
  service: types.string,
  estPickupTime: types.maybe(types.union(types.string, types.number)),
  estDeliveryTime: types.maybe(types.union(types.string, types.number)),
  price: types.number,
  priceMax: types.maybeNull(types.number),
  isSameDay: types.boolean,
});
